import React from "react";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import AdminTable from "../Helpers/AdminTable";
import TableTitle from "../Helpers/TableTitle";
import { useState } from "react";
import { paymentsAction } from "src/store/Slices/Administrator/PaymentsSlice";
import SureModal from "src/components/Modals/SureModal";
import AddEditPaymentModal from "./Modals/AddEditPaymentModal";
import AntdMobileTable from "src/components/AntdMobileTable/AntdMobileTable";

const Payments = ({ mnemo }) => {
    const dispatch = useDispatch();
    const searchInput = useRef(null);

    const items = [
        // {
        //     key: '1',
        //     label: 'Редактировать',
        //     onClick: () => { setIsOpenAddEditModal({ open: true, flag: 'edit' }) }
        // },
        {
            key: "2",
            label: "Удалить",
            onClick: () => {
                setIsOpenDeleteModal(true);
            },
            disabled: !mnemo?.children?.find((el) => el.mnemo === "deleteBtn"),
        },
    ];

    const filterOptionsArr = [
        { label: "Фильрация", value: 0, index: undefined },
        { label: "По номеру", value: 1, index: "id", title: "Оплата" },
        { label: "По ФИО", value: 2, index: "clientFio", title: "ФИО" },
        {
            label: "По номеру телефона",
            value: 3,
            index: "phone",
            title: "Номер телефона",
        },
        {
            label: "По дате платежа",
            value: 4,
            index: "paymentDate",
            title: "Дата платежа",
        },
        { label: "По сумме", value: 5, index: "price", title: "Сумма" },
        {
            label: "По типу карты",
            value: 6,
            index: "cardType",
            title: "Тип карты",
        },
        {
            label: "По номеру карты",
            value: 7,
            index: "lastFour",
            title: "Номер карты",
        },
    ];

    const [isDeleted, setIsDeleted] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [paymentInfo, setPaymentInfo] = useState();
    const [isOpenAddEditModal, setIsOpenAddEditModal] = useState({
        open: false,
        flag: "",
    });
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);

    // STORE
    const paymentsList = useSelector(
        (state) => state.PaymentsSlice.paymentsList
    );
    const paymentsListLoading = useSelector(
        (state) => state.PaymentsSlice.paymentsListLoading
    );

    const onClickDelete = () => {
        dispatch(
            paymentsAction({ flag: "delete", value: { id: paymentInfo.id } })
        ).then(() => {
            dispatch(paymentsAction({ flag: "get" }));
            setIsOpenDeleteModal(false);
        });
        setPage(1);
        setPageSize(20);
    };

    const searchItemsMap = (keys, values) => {
        const formattedItems = {};
        if (keys && values) {
            keys.forEach((key, index) => {
                if (values[index] && values[index][0]) {
                    if (key === "id") {
                        formattedItems["idFrom"] = values[index][0];
                        formattedItems["idTo"] = values[index][1];
                    } else if (key === "price") {
                        formattedItems["priceFrom"] = values[index][0];
                        formattedItems["priceTo"] = values[index][1];
                    } else if (key === "paymentDate") {
                        formattedItems["DateFrom"] = values[index][0];
                        formattedItems["DateTo"] = values[index][1];
                    } else {
                        formattedItems[key] = values[index][0];
                    }
                }
            });
            return formattedItems;
        }
    };

    const clickOnAction = (element) => {
        setPaymentInfo(element);
    };

    const handlePaginationChange = (page, pageSize) => {
        dispatch(
            paymentsAction({
                flag: "get",
                value: {
                    count: pageSize,
                    offset: pageSize * (page - 1),
                },
            })
        );
        setPage(page);
        setPageSize(pageSize);
    };

    const onClickSearchItem = (selectedKeys, dataIndex) => {
        setPage(1);
        setPageSize(20);
        dispatch(
            paymentsAction({
                flag: "get",
                value: {
                    isDeleted: isDeleted,
                    [`${dataIndex}`]: selectedKeys[0],
                },
            })
        );
    };

    const handleTableChange = (pagination, filters, sorter) => {
        const payload = searchItemsMap(
            Object.keys(filters),
            Object.values(filters)
        );
        dispatch(
            paymentsAction({
                flag: "get",
                value: {
                    isDeleted: isDeleted,
                    count: pagination.pageSize,
                    offset: pagination.pageSize * (pagination.current - 1),
                    orderBy: sorter?.column?.dataIndex,
                    isDesc: sorter.order
                        ? sorter.order === "ascend"
                            ? true
                            : false
                        : undefined,
                    ...payload,
                },
            })
        );
        setPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    useEffect(() => {
        dispatch(paymentsAction({ flag: "get" }));
    }, []);

    const showDeletedItems = (value) => {
        setIsDeleted(value);
        dispatch(paymentsAction({ flag: "get", value: { isDeleted: value } }));
        setPage(1);
        setPageSize(20);
    };

    return (
        <>
            <AddEditPaymentModal
                visible={isOpenAddEditModal}
                setVisible={setIsOpenAddEditModal}
                paymentInfo={paymentInfo}
                setPage={setPage}
                setPageSize={setPageSize}
            />
            <SureModal
                visible={isOpenDeleteModal}
                setVisible={setIsOpenDeleteModal}
                onClickYes={onClickDelete}
            />
            {window.innerWidth >= 768 ? (
                <AdminTable
                    page={page}
                    setPage={setPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    onChange={handleTableChange}
                    loading={paymentsListLoading}
                    onClickRowOne={(record) => {
                        setPaymentInfo(record);
                    }}
                    columns={paymentsList}
                    rows={paymentsList?.data?.value?.rows}
                    total={paymentsList?.data?.value?.totalCount}
                    title={() => (
                        <TableTitle
                            isDeleted={isDeleted}
                            showDeletedItems={showDeletedItems}
                            onClickOpenModal={() => {
                                setIsOpenAddEditModal({
                                    open: true,
                                    flag: "add",
                                });
                            }}
                            mnemoButton={
                                !mnemo?.children?.find(
                                    (el) => el.mnemo === "insertBtn"
                                )
                            }
                            mnemoSwitcher={
                                !mnemo?.children?.find(
                                    (el) => el.mnemo === "isDeletedBtn"
                                )
                            }
                        />
                    )}
                    items={items}
                    isDeleted={isDeleted}
                />
            ) : (
                <AntdMobileTable
                    page={page}
                    setPage={setPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    elementsList={paymentsList}
                    elementsListLoading={paymentsListLoading}
                    setIsOpenAddEditModal={setIsOpenAddEditModal}
                    setIsOpenDeleteModal={setIsOpenDeleteModal}
                    items={items}
                    onChange={handleTableChange}
                    filterOptionsArr={filterOptionsArr}
                    clickOnAction={clickOnAction}
                    handlePaginationChange={handlePaginationChange}
                    searchInput={searchInput}
                    onClickSearchItem={onClickSearchItem}
                />
            )}
        </>
    );
};

export default Payments;
